import { getTheme } from '@nobia/zeus-components/lib/themes'
import { transparentize } from '@nobia/zeus-components/lib/helpers/polished'

const theme = getTheme('magnet')

const primaryColor = '#192228'
const secondaryColor = 'rgba(106, 145, 173, 0.10)'

const lineColor = '#e0e4f1'

const tone1 = '#f7efe9'
const tone2 = '#faf5f2'
const tone3 = '#F2E8E1'
const tone4 = '#F9F4F0'

const item1 = '#666'
const item2 = '#ccc'
const item3 = '#e7e7e7'
const item4 = '#f2f2f2'

const black = '#192228'
const black2 = '#001B33'
const white = '#fff'

const brickRed = '#BC422C'
const lighterBlue = 'rgba(106, 145, 173, 0.10)'
const lightBlue = '#E0E5F1'
const financeGreen = '#578C6D';
const betterBlue = '#122126'

export const magnetDstPalette = {
  brandNavy: '#2F465A',
  steelBlue: '#6F93AE',
  paleAqua: '#A4D5DA',
  plum: '#744E5D',
  coral: '#E68E7E',
  warmTaupe: '#756965',
  camel: '#AF896B',
  sage: '#748678',
  straw: '#D9D47E',
}

export default {
  grid: {
    // TODO: move to theme
    container: '1440px',
  },
  dst: magnetDstPalette,
  base: {
    background: theme.colors.white,
    fontFamily: 'Montserrat, Arial, sans-serif',
    secondaryBackground: secondaryColor,
    color: primaryColor,
    colorHover: '#888',
    border: `1px solid ${lineColor}`,
    icon: {
      color: '#b2b6bc',
    },
    newDST: {
      primaryBlue: magnetDstPalette.brandNavy,
      secondaryBlue: magnetDstPalette.steelBlue,
      tertiaryBlue: magnetDstPalette.paleAqua,
      plum: magnetDstPalette.plum,
      coral: magnetDstPalette.coral,
      warmTaupe: magnetDstPalette.warmTaupe,
      camel: magnetDstPalette.camel,
      sage: magnetDstPalette.sage,
      straw: magnetDstPalette.straw,
      fontFamily: 'Montserrat, Arial, sans-serif',
      surface: white,
      borderSubtle: 'rgba(0, 0, 0, 0.1)',
      listingHeaderStrip: '#fcf0ee',
      listingTableHeader: '#F9E1DD',
      textOnLight: magnetDstPalette.brandNavy,
      textOnLightMuted: 'rgba(47, 70, 90, 0.7)',
      textOnLightExtraMuted: 'rgba(47, 70, 90, 0.6)',
      dashedBorder: '1px dashed rgba(47, 70, 90, 0.3)',
      messageBadgeText: white,
      messageBadgeBackground: '#BC422C',
      sectionHeading: magnetDstPalette.brandNavy,
      panelBackground: '#FCF0EE',
      panelBorder: 'rgba(47, 70, 90, 0.15)',
      mutedText: 'rgba(18, 33, 38, 0.6)',
      statusOnline: '#43B65F',
      toggleOffTrack: '#888F8A',
      visibilityToggleKnobBorder: 'rgba(0, 0, 0, 0.25)',
      dropzoneBackground: 'rgba(255, 255, 255, 0.6)',
      autoSavedBadge: '#1e9e4b',
      upcomingAccent: magnetDstPalette.coral,
      pastAccent: '#B0B0B0',
      cancelledAccent: '#8E959D',
      noteInputBackground: 'rgba(230, 142, 126, 0.15)',
      noteInputBorder: magnetDstPalette.coral,
      taskDueText: '#C57A6C',
      taskAddButtonBorder: 'rgba(47, 70, 90, 0.2)',
      taskCheckboxBorder: 'rgba(18, 33, 38, 0.4)',
      activityTableRowTint: 'rgba(252, 240, 238, 0.8)',
      cardShadow: '3px 4px 7px 0px rgba(0, 0, 0, 0.12)',
      warningBannerBackground: '#704455',
      beigeSurface: tone3,
      beigeSurfaceHover: '#eaddd4',
      textOnBeige: betterBlue,
      textMutedNavy: black2,
      statusDotOnline: '#2f8944',
      modalCardShadow: '3px 4px 8px 0px rgba(0, 0, 0, 0.15)',
      modalOverlay: 'rgba(0, 0, 0, 0.5)',
      actionButton: {
        toolbarGap: '15px',
        height: '37px',
        borderRadius: '5px',
        padding: '4px 20px',
        fontFamily: 'Montserrat, Arial, sans-serif',
        fontSize: '13px',
        fontWeight: 600,
        lineHeight: '26px',
        minWidth: '70px',
        maxWidth: '280px',
        outlineBorder: `1px solid ${magnetDstPalette.brandNavy}`,
        outlineText: magnetDstPalette.brandNavy,
        outlineBackground: 'transparent',
        primaryBackground: magnetDstPalette.brandNavy,
        primaryText: white,
        sidebarMobile: {
          sectionPadding: '16px 15px',
          gap: '17px',
          height: '42px',
          padding: '4px 10px',
          borderRadius: '5px',
          minWidth: '0',
          maxWidth: 'none',
          outlineBorder: `1px solid ${theme.colors.white}`,
          outlineText: theme.colors.white,
          outlineBackground: 'transparent',
          primaryBackground: theme.colors.white,
          primaryText: magnetDstPalette.brandNavy,
        },
      },
    },
    brickRed
  },
  header: {
    title: {
      fontWeight: 700,
      fontSize: '23px',
    },
    breakpoint: 721,
    logo: {
      width: '79px',
      md: {
        width: '100px',
      },
    },
    colors: {
      primaryColor: theme.colors.white,
      primaryBackground: primaryColor,
      secondaryColor: theme.colors.white,
      secondaryBackground: primaryColor,
      iconColor: theme.colors.white,
      iconBackground: 'none',
    },
  },
  buttons: {
    primary: {
      color: white,
      background: primaryColor,
      activeBackground: transparentize(0.15, primaryColor),
    },
    secondary: {
      color: primaryColor,
      background: white,
      activeBackground: transparentize(0.15, white),
    },
  },
  typography: {
    link: {
      color: '#002b5e',
    },
    paragraph: {
      fontSize: '16px',
      fontFamily: 'Montserrat, Arial, sans-serif',
      color: primaryColor,
    },
    pageTitle: {
      color: primaryColor,
      fontFamily: 'Montserrat, Arial, sans-serif',
      fontSize: '36px',
      lineHeight: '40px',
      fontWeight: 650,
      md: {
        fontSize: '36px',
        lineHeight: '40px',
      },
    },
    heading3: {
      fontFamily: 'Montserrat, Arial, sans-serif',
      fontWeight: 650,
    },
    heading4: {
      fontFamily: 'Montserrat, Arial, sans-serif',
      fontSize: '16px',
      lineHeight: '22px',
      fontWeight: 650,
      md: {
        fontSize: '21px',
        lineHeight: '27px',
      },
    },
    heading5: {
      fontFamily: 'Montserrat, Arial, sans-serif',
      fontSize: '16px',
      lineHeight: '22px',
      fontWeight: 650,
      md: {
        fontSize: '18px',
        lineHeight: '24px',
      },
    },
    heading6: {
      fontFamily: 'Montserrat, Arial, sans-serif',
      fontSize: '16px',
      lineHeight: '22px',
      fontWeight: 650,
      letterSpacing: 0,
      textTransform: 'uppercase',
      md: {
        fontSize: '16px',
        lineHeight: '22px',
        letterSpacing: 0,
      },
    },
    byline: {
      fontSize: '13px',
      color: item1,
      fontWeight: 200,
    },
  },
  forms: {
    height: '42px',
    border: `1px solid ${lineColor}`,
    borderRadius: '5px',
    fontFamily: 'Montserrat, Arial, sans-serif',
    searchIconTop: '32px',
    colors: {
      background: theme.colors.white,
    },
    currency: {
      left: '23px',
      symbol: {
        top: '10px',
        left: '10px',
      },
    },
  },
  button: {
    fontSize: '15px',
    padding: '1.0714285714285714rem 3.2142857142857144rem',
    borderRadius: '5px',
  },
  smallButton: {
    padding: '0 14px',
    borderRadius: '5px',
    fontSize: '14px',
    textTransform: 'none',
    height: '29px',
  },
  progressIcon: {
    complete: {
      background: theme.colors.green,
    },
    incomplete: {
      background: theme.colors.darkGrey,
    },
  },
  dropdownMenu: {
    width: '240px',
    background: '#ffffff',
    color: primaryColor,
    colors: {
      financeGreen,
      brickRed,
      tone1,
      black2,
    },
    border: '1px solid #e0e4f1',
    button: {
      borderRadius: '20px',
      border: '1.5px solid #fff',
      activeBackground: 'rgba(255, 255, 255, 0.1)',
      color: '#fff',
      fontWeight: '300',
      textTransform: 'none',
      fontSize: '14px',
    },
    item: {
      last: {
        background: '#f6faff',
      },
    },
  },
  navbar: {
    backgroundColor: theme.colors.white,
    color: theme.colors.primary,
  },
  table: {
    colors: {
      headerBackground: secondaryColor,
      background: theme.colors.backgroundPrimary,
      activeBackground: '#f6fafe',
    },
    infoIcon: {
      opacity: 1,
    },
  },
  box: {
    borderRadius: '10px',
    border: '1px solid #e0e4f1',
    colors: {
      headerBackground: secondaryColor,
      background: theme.colors.backgroundPrimary,
    },
  },
  searchFilter: {
    borderRadius: '10px',
    border: '1px solid #e0e4f1',
    background: secondaryColor,
  },
  status: {
    background: 'rgba(106, 145, 173, 0.10)',
  },
  customerInfo: {
    title: {
      fontFamily: 'Montserrat, Arial, sans-serif',
      fontWeight: 650,
      fontSize: '16px',
    },
    description: {
      fontSize: '14px',
    },
  },
  message: {
    borderRadius: '6px',
  },
  logEntry: {
    border: '2px solid rgba(106, 145, 173, 0.10)',
  },
  note: {
    background: '#d4ddf6',
  },
  filter: {
    select: {
      dropdown: {
        top: '55px',
      },
    },
  },
  productImage: {
    borderRadius: '6px',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)',
    width: '150px',
    height: '150px',
  },
  form: {
    background: 'rgba(106, 145, 173, 0.10)',
  },
  sidebar: {
    background: magnetDstPalette.brandNavy,
    border: `1px solid rgba(255, 255, 255, 0.2)`,
    activeBackground: `${magnetDstPalette.steelBlue}50`,
    activeIndicator: magnetDstPalette.coral,
    badgeBackground: brickRed,
    navItem: {
      color: white,
      fontFamily: 'Montserrat, Arial, sans-serif',
      fontSize: '15px',
      fontWeight: 400,
      activeWeight: 500,
      height: '50px',
      iconSize: '20px',
    },
    topBar: {
      background: magnetDstPalette.brandNavy,
      height: '66px',
      boxShadow: '0 4px 10px rgba(0, 0, 0, 0.08)',
    },
    userProfile: {
      fontFamily: 'Montserrat, Arial, sans-serif',
      avatarBg: magnetDstPalette.coral,
      avatarSize: '32px',
      statusOnline: '#43B65F',
      fontSize: '14px',
      lightFontWeight: 300,
    },
    title: {
      fontFamily: 'Montserrat, Arial, sans-serif',
      fontWeight: 700,
      fontSize: '16px',
      color: white,
    },
    storeSelect: {
      height: '37px',
      borderRadius: '3px',
      borderColor: 'rgba(18, 33, 38, 0.2)',
      chevronTop: '15px',
    },
  },
  messages: {
    wrapper: {
      borderColor: 'rgba(18, 33, 38, 0.10)',
      textColor: betterBlue,
      fontFamily: 'Montserrat, Arial, sans-serif',
    },
    sendMessage: {
      background: lighterBlue,
      button: {
        background: magnetDstPalette.brandNavy,
        color: white,
      },
    },
    bubble: {
      store: 'rgba(106, 144, 173, 0.10)',
      customer: '#FCF0EE',
      initials: {
        background: magnetDstPalette.brandNavy,
        backgroundSent: magnetDstPalette.coral,
      },
    },
    input: {
      borderColor: lineColor,
    },
    textarea: {
      borderColor: lightBlue,
    },
    newMessages: {
      borderColor: item3,
      color: brickRed,
    },
    conversationList: {
      selectedBackground: '#CFE3FF',
      selectedShadow: '3px 5px 5px -1px rgba(0, 0, 0, 0.2)',
    },
  },
  storeStaffSelect: {
    fontSize: '14px',
    lineHeight: '20px',
    fontFamily: 'Montserrat, Arial, sans-serif',
    contentFontWeight: 400,
    labelFontWeight: 600,
    color: magnetDstPalette.brandNavy,
  },
}
